module.exports = __webpack_public_path__ + "img/OKXWallet.5cf837c8.svg";